import * as types from "../actions/ActionTypes";
import InitialState from "./InitialState";

export default function hourUtilizationRequestReducer(state = InitialState.hourUtilizationRequests, action) {
  switch (action.type) {
    case types.SAVE_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return [...state, { ...action.hourUtilizationRequest }];
    case types.LOAD_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return action.hourUtilizationRequests;
    case types.UPDATE_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return state.map((request) => (request.id === action.updatedRequest.id ? action.updatedRequest : request));
    case types.CANCEL_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return state.filter((request) => request.id !== action.canceledRequest.id);
    case types.ACCEPT_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return state.map((request) => (request.id === action.updatedRequest.id ? action.updatedRequest : request));
    case types.SAVE_RATE_AGNOSTIC_HOUR_UTILIZATION_REQUEST_SUCCESS:
      return [...state, ...action.hourUtilizationRequests];
    default:
      return state;
  }
}
